module.exports = __webpack_public_path__ + "img/productions_29.1f6ad781.png";